import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { marked } from 'marked';

@Pipe({
    name: 'chatMarkdown',
    standalone: false
})
export class ChatMarkdownPipe implements PipeTransform {
    private static configured = false;
    private renderer = new marked.Renderer();

    constructor(private sanitizer: DomSanitizer) {
        if (!ChatMarkdownPipe.configured) {
            this.renderer.link = (href, title, text) => {
                const safeHref = href || '';
                const safeTitle = title ? ` title="${title}"` : '';
                return `<a href="${safeHref}"${safeTitle} target="_blank" rel="noopener noreferrer">${text}</a>`;
            };

            marked.setOptions({
                gfm: true,
                breaks: true,
                renderer: this.renderer
            });

            ChatMarkdownPipe.configured = true;
        }
    }

    transform(value: string | null | undefined): SafeHtml {
        if (!value) {
            return '';
        }

        const rawHtml = marked.parse(value) as string;
        const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, rawHtml) || '';

        return this.sanitizer.bypassSecurityTrustHtml(sanitized);
    }
}
